import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { I18NextPipe } from 'angular-i18next';
import { interval, Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { getDashboardsConfigState, State } from 'src/app/dashboards/state';
import { register } from 'src/app/dashboards/widget/widget-helpers/helpers';
import { widgetType } from 'src/app/enums';
import { gridItem } from 'src/app/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { WidgetBaseComponent } from '../../widget-base.component';

@Component({
    selector: 'app-queues',
    templateUrl: './queues.component.html',
    styleUrls: ['./queues.component.scss'],
    standalone: false
})
@register("Queues")
export class QueuesComponent implements OnInit, OnDestroy, WidgetBaseComponent {

  @Input() public isInWizard: boolean;
  @Output() public restrictedDataEvent = new EventEmitter<boolean>();

  restrictedData: boolean = false;

  _gridItem: gridItem;
  get gridItem(): gridItem {
    return this._gridItem;
  }
  @Input() set gridItem(value: any) {
    this._gridItem = value;
    setTimeout(() => {
      this.notifier.next();
    }, 0);
  }

  _dataEquality: boolean;
  get dataEquality(): boolean {
    return this._dataEquality;
  }
  @Input() set dataEquality(value: boolean) {
    this._dataEquality = value;
    if (!value) {
        this.getData();
    }
  }

  _colorSchemeId: number;
  get colorSchemeId(): number {
    return this._colorSchemeId;
  }
  @Input() set colorSchemeId(value: number) {
    this._colorSchemeId = value;
  }

  public data: any[];
  public alarmItems: any;
  public propsWithIds: any[];

  public queues$: Observable<any[]>;
  public terminate$ = new Subject<void>();
  public notifier = new Subject<void>();

  public widgetType = widgetType;

  public type: string = "Queue";

  constructor(private DashboardsService: DashboardService, private store: Store<State>, private i18nextPipe: I18NextPipe) { }

  ngOnInit(): void {
    this.getData();
    if (!this.isInWizard) {
      this.store.select(getDashboardsConfigState).pipe(take(1)).subscribe(config => {
        interval(config.widgetRefreshInterval.realTime * 1000).pipe(takeUntil(this.terminate$)).subscribe(_ => { this.getData(); });
      });
    }
  }

  ngOnDestroy(): void {
    this.terminate$.next()
    this.terminate$.complete()
  }

  getData(): void {
    if (this.gridItem.setup.queueIds != undefined && this.gridItem.setup.queuePropertiesIds != undefined) {
      if (this.gridItem.setup.queueIds.length > 0 && this.gridItem.setup.queuePropertiesIds.length > 0) {
        this.queues$ = this.DashboardsService.getQueueData(this.gridItem.setup.queueIds || [], this.gridItem.setup.queuePropertiesIds || []);
        this.queues$.subscribe((d: any) => {
          this.data = d.data;
          this.alarmItems = d.queueAlarmItems;
          let propsWithIds = [];
          if (d.data && d.data.length > 0) {
            let propsKeys = Object.keys(d.data[0]);
            propsKeys = propsKeys.filter(function (value, index, arr) {
              return value.toLowerCase() !== "id" && value.toLowerCase() !== "name" && value.toLocaleLowerCase() !== "alarmflag";
            });
            for (let i = 0; i < this.gridItem.setup.queuePropertiesIds.length; i++) {
              propsWithIds.push({
                prop: propsKeys[i],
                id: this.gridItem.setup.queuePropertiesIds[i]
              });
            }
            this.propsWithIds = propsWithIds;
          }
          this.notifier.next();
          this.restrictedData = d.data.length == 0;
          this.restrictedDataEvent.emit(d.data.length > 0 && d.data.length != this.gridItem.setup.queueIds.length);
        });
      }
    }
  }
}
